
































import vue from "vue";
import {
  VUEX_EXERCISE_ACTION_NAMES,
  VUEX_EXERCISE_GETTER_NAMES,
  VUEX_EXERCISE_NAMESPACE
} from "@tt-app/constants";

import IconClose from "@joyz/app-core/assets/icons/black/Close.svg";
import IconTerratalk from "@joyz/app-core/assets/logo/terratalk-icon-fullcolor.svg";

const { ATTEMPT_EXERCISE_CLOSE } = VUEX_EXERCISE_ACTION_NAMES;
const { LOG_ID, REVIEW_PAGE } = VUEX_EXERCISE_GETTER_NAMES;

interface Data {
  icons: {
    [key: string]: string;
  };
  modals: {
    navigation: {
      opened: boolean;
    };
  };
}

interface Methods {
  handleCloseClick: () => void;
}

interface Computed {
  chapterTitle: string;
  courseTitle: string;
  exerciseDetails: any;
  exerciseTitle: string;
  feedbackRouteParams: {
    withFeedback: string;
    logId: string;
  };
  inProgress: boolean;
  isReview: boolean;
  logId: number;
  sectionTitle: string;
}

export default vue.extend<Data, Methods, Computed, any>({
  name: "ExerciseHeader",

  data() {
    return {
      icons: {
        close: IconClose,
        terratalk: IconTerratalk
      },
      modals: {
        navigation: {
          opened: false
        }
      }
    };
  },

  methods: {
    handleCloseClick() {
      this.$store.dispatch(`${VUEX_EXERCISE_NAMESPACE}/${ATTEMPT_EXERCISE_CLOSE}`);
    }
  },

  computed: {
    chapterTitle() {
      return this.exerciseDetails?.chapter?.title;
    },

    courseTitle() {
      return this.exerciseDetails?.course?.title;
    },

    exerciseDetails() {
      return this.$store.state.exercise.details;
    },

    exerciseTitle() {
      return this.exerciseDetails?.exercise?.title;
    },

    feedbackRouteParams() {
      const isReview = (this as any).isReview;
      const logId = (this as any).logId;

      return {
        withFeedback: Boolean(!isReview).toString(),
        logId: logId.toString()
      };
    },

    inProgress() {
      return this.$store.state.exercise.inProgress;
    },

    isReview() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${REVIEW_PAGE}`];
    },

    logId() {
      return this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${LOG_ID}`];
    },

    sectionTitle() {
      return this.exerciseDetails?.section?.title;
    }
  }
});
